import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function About() {
  const { content } = useContent();
  const c = content || {};
  const certs = c.about_certifications || [];
  const education = c.about_education || [];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24" data-testid="about-page">
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">[ 02 · about ]</div>
      <motion.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-4xl"
      >
        {c.about_headline}
      </motion.h1>

      <div className="grid lg:grid-cols-12 gap-10 mt-16">
        <div className="lg:col-span-7 space-y-8">
          <section>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-accent mb-3">[ the work ]</div>
            <p className="text-lg leading-relaxed" data-testid="about-body">{c.about_body}</p>
          </section>
          <section>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-accent mb-3">[ the ministry ]</div>
            <p className="text-lg leading-relaxed">{c.about_ministry}</p>
          </section>
          <section>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-accent mb-3">[ the transition ]</div>
            <p className="text-lg leading-relaxed">{c.about_transition}</p>
          </section>

          <div className="pt-8">
            <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground text-background font-mono text-xs uppercase tracking-[0.2em]">
              Start a conversation <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <aside className="lg:col-span-5 space-y-6">
          {certs.length > 0 && (
            <div className="p-6 rounded-2xl border border-border bg-card" data-testid="about-certifications">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-4">Certifications</div>
              <ul className="space-y-2">
                {certs.map((cert) => (
                  <li key={cert} className="flex items-start gap-2 text-sm">
                    <span className="text-accent font-mono">+</span>
                    <span>{cert}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {education.length > 0 && (
            <div className="p-6 rounded-2xl border border-border bg-card" data-testid="about-education">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-4">Education</div>
              <ul className="space-y-3">
                {education.map((e, idx) => (
                  <li key={`${e.school}-${idx}`} className="text-sm">
                    <div className="font-serif text-base">{e.school}</div>
                    <div className="text-muted-foreground text-xs mt-0.5">{e.detail}</div>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {(c.about_current_role || c.about_current_company) && (
            <div className="p-6 rounded-2xl border border-border bg-secondary/40" data-testid="about-current">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">Currently</div>
              {c.about_current_role && <div className="font-serif text-xl">{c.about_current_role}</div>}
              {c.about_current_company && <div className="text-sm text-muted-foreground">{c.about_current_company}</div>}
            </div>
          )}
        </aside>
      </div>
    </div>
  );
}
